module.exports = __webpack_public_path__ + "static/stacheLogo-2499a1b940761220d2e1b656ae3a975d.png";